import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { Paso6pagePageRoutingModule } from './paso6page-routing.module';

import { Paso6pagePage } from './paso6page.page';
import { IonicSelectableModule } from 'ionic-selectable';
import {MiscomponentesModule} from '../miscomponentes/componentes.module'


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    Paso6pagePageRoutingModule,
    IonicSelectableModule,
    MiscomponentesModule
  ],
  declarations: [
    Paso6pagePage,
    
  ]
})
export class Paso6pagePageModule {}
